import styled from 'styled-components'
import { Row } from 'react-styled-flexboxgrid-tmp'
import Flex from 'Components/Flex'
import AppButton from 'Components/AppButton'

import { BREAK_POINT_SM } from '@CSSVars/variables'
import {
  SECONDARY_NORMAL_COLOR,
  PRIMARY_NORMAL_COLOR,
  GREY_NORMAL_COLOR,
  CLICKABLE_COLOR,
  TEXT_GREY,
  FONT_BASE_COLOR,
} from '@CSSVars/colors'

export const _ShareMenuRow = styled(Row)`
  width: 100%;
  margin: 0 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`


export const _SelectedBtn = styled.div`
  color: ${CLICKABLE_COLOR};
  font-size: 14px;
  cursor: pointer;
  transition: all .3s;
  @media screen and (max-width: ${BREAK_POINT_SM}) {
    padding-left: 20px;
  }
`

export const _ShareBtnContainer = styled(Flex)`
  display: flex;
  gap: 8px;
  div {
    margin-right: 10px;
    svg {
      margin-left: 24px;
      fill: ${GREY_NORMAL_COLOR};
      transition: fill .3s;
    }
    &:hover {
      svg {
        fill: ${GREY_NORMAL_COLOR};
      }
    }
  }


  ${({ active }) => (active ? `
    div {
      cursor: pointer;
      svg {
        fill: ${SECONDARY_NORMAL_COLOR};
      }
      &:hover {
        svg {
          fill: ${PRIMARY_NORMAL_COLOR};
        }
      }
    }
  ` : '')}

  @media screen and (max-width: ${BREAK_POINT_SM}) {
    width: 100%;
    height: 64px;
    padding: 0 24px;
    justify-content: center;
    background-color: white;
    position: fixed;
    bottom: ${({ isMobileApp }) => (isMobileApp ? '80px' : '0')};
    left: 0;
    z-index: 101;
    box-shadow: 0px -3px 6px rgba(0, 0, 0, 0.15);
  }
`

export const _CompareBtn = styled(AppButton)`
  min-width: 138px;
  max-width: 172px;
  height: 44px;
  font-weight: 500;
  padding: 11px;
  path {
        fill:  ${({ disabled }) => (disabled ? TEXT_GREY : 'white')};
      }

      svg {
        margin-right: 7px;
      }
      span {
        color:  ${({ disabled }) => (disabled ? TEXT_GREY : 'white')};
        font-weight: 500 !important;
        font-family: Montserrat;
        font-size: 14px;
        line-height: 22px;
        white-space: nowrap;
      }
  ${({ disabled }) => (disabled ? `
      && {
        background-color: transparent!important;
      }
    ` : '')}
      @media screen and (max-width: ${BREAK_POINT_SM}) {
        width: 172px;
  }
`

export const _PrintBtn = styled(AppButton)`
  width: 82px;
  height: 44px;
  span {
    margin-left: 6px;
  }
  padding: 0;
  ${({ disabled }) => (disabled ? `
      && {
        background-color: transparent!important;
      }
      color: ${TEXT_GREY};
    ` : '')}
`


export const _EmailBtn = styled(AppButton)`
  width: 82px;
  height: 44px;
  span {
    margin-left: 6px;
  }

  path {
    stroke: ${FONT_BASE_COLOR};
  }

  path:first-child {
    fill: transparent;
  }
  path:last-child {
    fill: transparent;
  }
  padding: 0;
  ${({ disabled }) => (disabled ? `
      && {
        background-color: transparent!important;
      }
      color: ${TEXT_GREY};
    ` : '')}
`
